import React from 'react';
import { arrayOf, object, string } from 'prop-types';
import styled from 'styled-components';

import Divider from './Divider';
import BenefitList from './BenefitList';
import BenefitAccordion from './BenefitAccordion';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 0px;
  background-color: ${({ bgColor }) => bgColor};
`;

const Text = styled.h2`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 24px;
  line-height: 1.33;
  text-align: center;
  margin-bottom: 32px;
  color: #4a4a4a;
  font-weight: 600;
`;

const BenefitBox = ({ benefits, bgColor }) => (
  <Container id="benefits" bgColor={bgColor}>
    <Divider />
    <Text>Benefícios do Plano Profissional</Text>
    <BenefitList benefits={benefits} />
    <BenefitAccordion benefits={benefits} />
  </Container>
);

BenefitBox.propTypes = {
  benefits: arrayOf(object),
  bgColor: string,
};

BenefitBox.defaultProps = {
  benefits: [],
  bgColor: '#ffffff',
};

export default BenefitBox;
